module.exports = __webpack_public_path__ + "static/hackathon-sponsor-incentive-4e83b26468614795a3caaddb7198dab0.png";